import { Form } from "react-bootstrap";
import { Skeleton } from "@mui/material";

export default function SkeletonFormEspecie() {
  return (
    <div className="px-2">
      <section className="row">
        <div className="col-12 col-md-6 mx-auto">
          <Form.Group className="col-12">
            <Skeleton
              variant="text"
              width={145}
              className="mb-1"
              sx={{ fontSize: "16px" }}
              animation="wave"
            />
            <Skeleton
              variant="rectangular"
              className="rounded"
              animation="wave"
              width={"100%"}
              height={38}
            />
            <div style={{ height: "21px" }}></div>
          </Form.Group>
          <Form.Group className="col-12">
            <Skeleton variant="text" sx={{ fontSize: "16px" }} width={50} animation="wave" />
            <div className="d-flex align-items-center gap-2">
              <Skeleton
                variant="rectangular"
                animation="wave"
                width={32}
                height={16}
                style={{ borderRadius: "1.8rem" }}
              />
              <Skeleton variant="text" sx={{ fontSize: "16px" }} animation="wave" width={70} />
            </div>
            <div style={{ height: "21px" }}></div>
          </Form.Group>
        </div>

        <div className="col-6">
          <Form.Group className="col-12 ">
            <Skeleton
              variant="text"
              className="mb-1"
              sx={{ fontSize: "16px" }}
              width={120}
              animation="wave"
            />
            <Skeleton
              variant="rectangular"
              className="rounded"
              animation="wave"
              width={"100%"}
              height={38}
            />
            <Skeleton
              variant="rectangular"
              className="mt-2"
              animation="wave"
              width={"100%"}
              height={300}
            />
            <div style={{ height: "21px" }}></div>
          </Form.Group>
        </div>
      </section>
      <Skeleton variant="rectangular" animation="wave" width={66} height={29} className="rounded" />
      {/* </fieldset> */}
    </div>
  );
}
